import { Stack, Typography } from "@mui/material";
import NoDataSvg from "./no-data-svg";

const NoData = ({ message }: { message: string }) => {
  return (
    <Stack spacing={2} alignItems="center">
      <NoDataSvg />
      <Typography variant="body1" color="text.disabled">
        {message || "No data found, please try again later."}
      </Typography>
    </Stack>
  );
};

export default NoData;
